import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { environment } from '@environments/environment';
import { NgxsModule } from '@ngxs/store';
import { AuthModule, LogLevel } from 'angular-auth-oidc-client';
import { NgxSpinnerModule } from 'ngx-spinner';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthResolverService } from './core/guards/auth.resolver';
import { CustomHttpInterceptor, LoaderInterceptor } from './core/interceptors';
import { CommonService, DummyService } from './core/services';
import { AngularMaterialModule } from './core/sharedmodules/angular-material/angular-material.module';
import { HomeModule } from './modules/home/home.module';
import { NgApexchartsModule } from 'ng-apexcharts';

@NgModule({
  declarations: [AppComponent],
  imports: [
    AuthModule.forRoot({
      config: {
        authority: `${environment.stsServerUrl}`,
        redirectUrl: window.location.origin,
        postLogoutRedirectUri: `${environment.identityLoginUrl}`,
        clientId: `${environment.clientId}`,
        scope: 'capium_myadmin_api openid offline_access',
        responseType: 'code',
        silentRenew: false,
        silentRenewUrl: `${window.location.origin}/silent-renew.html`,
        logLevel: LogLevel.Debug,
        useRefreshToken: true,
        historyCleanupOff: true,
        autoCleanStateAfterAuthentication: true,
        postLoginRoute: '/dashboard',
        unauthorizedRoute: `${environment.identityLoginUrl}`,
        autoUserInfo: false,
      },
    }),
    BrowserModule,
    AppRoutingModule,
    HomeModule,
    AngularMaterialModule,
    BrowserAnimationsModule,
    NgxSpinnerModule.forRoot({ type: 'ball-spin-fade' }),
    NgxsModule.forRoot([]),
    NgApexchartsModule
  ],
  providers: [
    CommonService,
    DummyService,
    AuthResolverService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CustomHttpInterceptor,
      multi: true,
    },
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
